// @ts-ignore
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { createTheme, NextUIProvider } from "@nextui-org/react";
import colors from "../colors";
var formattedColors = Object.fromEntries(Object.keys(colors).filter(function(k) {
    return colors.hasOwnProperty(k);
}).flatMap(function(colorName) {
    var colorObj = colors[colorName];
    if (typeof colorObj === "string") {
        return [
            [
                colorName,
                colorObj
            ]
        ];
    }
    return Object.keys(colorObj).map(function(colorNumber) {
        if (!colorName) {
            return [];
        }
        return [
            "".concat(colorName, "-").concat(colorNumber),
            colorObj[colorNumber]
        ];
    });
}).filter(Boolean));
// console.log(formattedColors)
var lightTheme = createTheme({
    type: "light",
    className: "light",
    theme: {
        colors: _object_spread_props(_object_spread({}, formattedColors), {
            backgroundContrast: "#fff"
        })
    }
});
var darkTheme = createTheme({
    type: "dark",
    className: "dark",
    theme: {
        colors: _object_spread_props(_object_spread({}, formattedColors), {
            backgroundContrast: colors.gray["800"]
        })
    }
});
export function NextUiStuff(_param) {
    var children = _param.children, rest = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(NextUIProvider, _object_spread_props(_object_spread({
        defaultTheme: "dark",
        attribute: "class",
        value: {
            light: lightTheme.className,
            dark: darkTheme.className
        },
        disableBaseline: true
    }, rest), {
        children: children
    }));
}
